import Vue from 'vue'
import VueCountdown from '@chenfengyuan/vue-countdown'

Vue.component('countdown', VueCountdown)
